import React from 'react'

const TermsIcon = () => {
  return (

<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M12.5007 1.66797H5.00065C4.55862 1.66797 4.1347 1.84356 3.82214 2.15612C3.50958 2.46868 3.33398 2.89261 3.33398 3.33464V16.668C3.33398 17.11 3.50958 17.5339 3.82214 17.8465C4.1347 18.159 4.55862 18.3346 5.00065 18.3346H15.0007C15.4427 18.3346 15.8666 18.159 16.1792 17.8465C16.4917 17.5339 16.6673 17.11 16.6673 16.668V5.83464L12.5007 1.66797Z" stroke="currentcolor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M11.666 1.66797V5.0013C11.666 5.44333 11.8416 5.86725 12.1542 6.17981C12.4667 6.49237 12.8907 6.66797 13.3327 6.66797H16.666" stroke="#616161" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.33268 7.5H6.66602" stroke="currentcolor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M13.3327 10.832H6.66602" stroke="currentcolor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M13.3327 14.168H6.66602" stroke="currentcolor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default TermsIcon